<template>
	<div id="contribute">
		<!-- 投稿专区 -->
		<webSearth @searthChange="searthChangeFun" />
		<div class="part2" >
			<div class="tit">
				<p>优秀案例</p>
				<b>Featured Cases</b>
			</div>

      <div class="cont">
        <el-table
            :data="tableData"
            style="width: 100%"
            :fit="true"
            empty-text="暂无优秀案例数据"
            header-cell-class-name="table-header-gray"
        >
          <!-- 第一列：案例标题/主要内容 (占据主要宽度) -->
          <el-table-column label="案例标题" min-width="200">
            <template slot-scope="scope">
              <div class="case-title">{{ scope.row.inpName }}</div>
              <!-- 如果有副标题或简介，可以在这里添加，例如： -->
              <!-- <div class="case-desc">简介：{{ scope.row.brief }}</div> -->
            </template>
          </el-table-column>

          <!-- 第二列：作者 (固定宽度) -->
          <el-table-column label="作者" width="150">
            <template slot-scope="scope">
                <span class="author-name">
                    <i class="el-icon-user-solid"></i> {{ scope.row.doctorName }}
                </span>
            </template>
          </el-table-column>

          <!-- 第三列：操作 (固定宽度，居右) -->
          <el-table-column label="操作" width="100" align="center">
            <template slot-scope="scope">
              <!-- stop 阻止事件冒泡，防止触发 row-click 导致重复跳转 -->
              <el-button
                  type="text"
                  size="small"
                  @click.stop="pageToDetails(scope.row)"
                  icon="el-icon-view"
              >
                查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-pagination
            class="pagination-container"
            background
            layout="prev, pager, next, total"
            :total="total"
            @current-change="handleCurrentChange"
            :current-page.sync="pageNum"
            :page-size="pageSize"
            :hide-on-single-page="true"
        ></el-pagination>
      </div>

    </div>



    <!-- 【新增】个人信息完善弹窗 -->
    <!-- 使用 v-if 确保组件销毁重建，获取最新数据 -->
    <el-dialog
        title="完善个人信息"
        :visible.sync="showUserInfoDialog"
        width="50%"
        top="5vh"
        :close-on-click-modal="false"
        custom-class="user-info-dialog"
        v-if="showUserInfoDialog"
    >
      <!-- 引入并挂载 editUser 组件 -->
      <edit-user ref="userEditForm" @editUserSuccess="handleUserInfoSuccess" />

      <div slot="footer" class="dialog-footer" style=" text-align: center; padding: 20px;">
        <el-button style="  width: 200px;
      height: 45px;
      font-size: 16px;" @click="showUserInfoDialog = false">暂不填写</el-button>
        <!-- 注意：提交动作在 editUser 组件内部完成，通过 emit 通知父组件 -->
      </div>
    </el-dialog>

		<el-dialog class="docView" :visible.sync="docViewShow" v-if="docViewShow">
      <!-- 浏览数展示（可选样式） -->
      <div class="view-count" style="position: absolute; top: 20px; right: 20px; background: rgba(0,0,0,0.5); color: white; padding: 4px 8px; border-radius: 4px; z-index: 10;">
        浏览 {{ viewCount }}
      </div>

			<iframe v-if="docview.documentType == 'TEXT'" :src="docview.downloadPath"
				:title="docview.documentName"></iframe>
			<!-- <video v-else :src="docview.downloadPath" controls intrinsicsize></video> -->
			<video-player v-else ref="videoPlayer" class="player-video" :playsinline="false" :options="playOptions"
				@pause="onPlayerPause($event)" />
		</el-dialog>


    <el-dialog top="10px" :visible.sync="contributeDialog" v-if="contributeDialog"  width="900px"    :close-on-click-modal="false" custom-class="contribute-dialog">
      <div class="dialog-body">
        <!-- 头部 -->
<!--        <div class="top">-->
<!--          <p>{{surveyInfo.surName}}</p>-->
<!--          &lt;!&ndash;          <b>contribute</b>&ndash;&gt;-->
<!--        </div>-->

        <!-- 可滚动内容区 -->
        <div class="dialog-content">
          <fm-generate-form
              :data="jsonData" print-read
              :value="editData"
              ref="generateForm"
          />
        </div>


<!--        &lt;!&ndash; 底部按钮 &ndash;&gt;-->
<!--        <div class="dialog-footer" >-->
<!--                    <el-button type="info" @click="handleCanal">关闭</el-button>-->
<!-- -->
<!--        </div>-->
      </div>
    </el-dialog>


	</div>
</template>

<script>
import {
  getProject, // 首页项目介绍
  excellentDocument, // 优秀稿件
  excellentCase,
  documentList, getUser // 入围作品
} from '@/request/api.js';
import editUser from '@/components/editUser'; // 假设你的文件路径是这个，请根据实际路径调整
	import webSearth from '@/components/webSearth'
	export default {
		name: 'contribute',
		components: {
			webSearth,editUser
    },
		data() {
			return {
        userInfo:{},
        showUserInfoDialog: false, // 控制个人信息弹窗显示
        currentRow: null,          // 暂存当前点击的行数据，以便后续使用
        contributeDialog: false,
        jsonData:{},
        editData:{},
        viewCount:"500+",
        search: '',
				active: '1',
				total: 0,
				pageSize: 12,
				pageNum: 1,
				tableData: [],
				total2: 0,
				pageNum2: 1,
				tableData2: [],
				hidden: true,
				ProjectData: '',
				docview: '',
				docViewShow: false,
				playOptions: {
					height: "100%",
					width: "100%",
					playbackRates: [1.0, 2.0, 3.0], // 可选的播放速度
					autoplay: true, // 如果为true,浏览器准备好时开始回放
					muted: false, // 默认情况下静音播放
					loop: false, // 是否视频一结束就重新开始
					preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据，auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
					language: "zh-CN",
					aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值，值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
					fluid: true, // 当true时，Video.js player将拥有流体大小，换句话说，它将按比例缩放以适应其容器
					sources: [{
						// type: "video/mp4", // 类型
						// src: require("./1.mp4"), // url地址，在使用本地的资源时，需要用require()引入，否则控制台会报错
					}],
					poster: "", // 设置封面地址
					notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息
					controlBar: {
						currentTimeDisplay: true,
						progressControl: true, // 是否显示进度条
						playbackRateMenuButton: true, // 是否显示调整播放倍速按钮
						timeDivider: true, // 当前时间和持续时间的分隔符
						durationDisplay: true, // 显示持续时间
						remainingTimeDisplay: true, // 是否显示剩余时间功能
						fullscreenToggle: true, // 是否显示全屏按钮
					},
				},
				mainColor: ''
			}
		},
		created() {
			this.mainColor = localStorage.getItem('mainColor');
			this.getQueryFun();
			this.getProjectFun();
			this.getexcellentDocument();

      const headToken = localStorage.getItem('headToken')
      if (headToken) {
        this.getUserFun()
      }

		},
		mounted() {},
		watch: {
			"$route": {
				handler(val) {
					this.getQueryFun(val);
				},
				deep: true
			}
		},
		methods: {
      // 获取用户信息
      getUserFun() {
        return getUser().then(res => { // 添加 return
          if (res.code == 200) {
            this.userInfo = res.data;
            console.log(this.userInfo);
            this.$forceUpdate();
            return res.data; // 返回数据供链式调用
          }
          return Promise.reject(res);
        });
      },
			// 搜索
			searthChangeFun(val) {
        // console.log("执行",val.content)
        this.search = val.content;
				this.hidden = false;
				this.pageNum2 = 1;
				this.getexcellentDocument()
			},




			// 获取优秀稿件列表
			getexcellentDocument() {
				let data = {
					current: this.pageNum,
					size: this.pageSize,
          caseType: this.active,
          search: this.search
				}
        excellentCase(data).then(res => {
					if (res.code == 200) {
						this.total = res.data.total;
						this.tableData = res.data.records;
					}
				})
			},

			// 首页项目介绍
			getProjectFun() {
				getProject().then(res => {
					if (res.code == 200) {
						let data = res.data;
						this.ProjectData = data;
						// this.mainColor = data.mainColor;
					}
				})
			},

			getQueryFun(val) {
				if (this.$route.query.type == 'searth') {
					this.hidden = false;
				} else {
					this.hidden = true;
				}
			},

			handleCurrentChange(val) {
				this.pageNum = val;
				this.getexcellentDocument();
			},


			pageToDetails(row) {
        //判断是否填写了用户姓名和医院信息 地区 职称，如果没有要填区填写才可以去查看
        // 1. 暂存当前行数据
        this.currentRow = row;
        // 2. 定义必填字段检查逻辑
        // 根据你的需求：姓名、医院、地区、职称
        const u = this.userInfo;

        // 注意：regionCodes 对应地区，jobTitle 对应职称，hospital 对应医院，fullName 对应姓名
        // 请根据实际返回数据结构调整字段名 (例如地区可能是 location 或 regionCodes)
        const isComplete =
            u.fullName && u.fullName.trim() !== '' &&
            u.hospital && u.hospital.trim() !== '' &&
            u.jobTitle && u.jobTitle.trim() !== '' &&
            (u.regionCodes || (u.location && u.location !== '')); // 兼容地区字段的不同命名

        if (!isComplete) {
          // 3. 如果信息不全，弹出编辑框
          this.$message.warning('查看优秀案例前，请先完善您的个人执业信息。');
          this.showUserInfoDialog = true;
          // 不需要 return，因为此时不会打开详情弹窗
        } else {
          // 4. 如果信息完整，直接打开详情
          this.openCaseDetail(row);
        }


			},
      // 封装打开详情的逻辑
      openCaseDetail(row) {
        try {
          this.jsonData = JSON.parse(row.surTemplate);
          if (row.inpEntContent) {
            this.editData = JSON.parse(row.inpEntContent);
          }
          this.contributeDialog = true;

        } catch (e) {
          this.$message.error('案例数据格式错误，无法加载');
          console.error(e);
        }
      },

      // 5. 处理用户信息提交成功的回调
      handleUserInfoSuccess(res) {
        // res 是子组件 emit 过来的参数 { type: 'success', login: false }
        if (res.type === 'success') {
          this.$message.success('信息完善成功！');
          this.showUserInfoDialog = false; // 关闭编辑弹窗

          // 刷新本地 userInfo 数据 (因为子组件可能已经改了，但为了保险可以重新拉取或直接使用新数据)
          // 这里假设子组件 emit 后，父组件的 userInfo 可能需要更新，或者子组件内部已经调用了 getUser
          // 最稳妥的方式是重新调用一次 getUser 确保数据最新，或者直接利用子组件更新后的状态
          this.getUserFun().then(() => {
            // 数据刷新后，再次尝试打开详情 (此时校验应该会通过)
            if (this.currentRow) {
              this.pageToDetails(this.currentRow);
            }
          });
        }
      },




		}
	}
</script>

<style lang="scss" scoped>
	$main-color: v-bind(mainColor);

	#contribute {
		display: flex;
		flex-direction: column;

		::v-deep .docView {
			height: 100vh;
			display: flex;
			align-items: center;
			justify-content: center;

			.el-dialog {
				margin: 0 !important;
				width: 1200px;
				height: 90vh;

				.el-dialog__body {
					height: 100%;
					overflow: hidden;
					display: flex;
					align-items: center;
					justify-content: center;


					iframe {
						width: 100%;
						height: 100%;
						border: none;
					}

					.video-player {
						flex: 1;
					}

					.vjs-big-play-button {
						position: absolute;
						left: 50%;
						top: 50%;
						transform: translate(-50%, -50%);
					}
				}
			}
		}


		.part1,
		.part2 {
			padding: 100px 0 0;

			.tit {
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				margin-bottom: 60px;

				p {
					font-size: 36px;
					text-align: center;
					color: rgba(31, 32, 34, 1);
				}

				b {
					font-size: 18px;
					text-align: center;
					color: $main-color;
				}
			}

			.cont {
				width: 1200px;
				margin: auto;


				::v-deep .el-table {
					.el-table__header {
						height: 0;

						.el-table__cell {
							padding: 0;
							height: 0;
						}
            /* 鼠标悬停整行高亮 */
            .el-table__row:hover {
              background-color: #f5f7fa !important;
              cursor: pointer;
            }



					}


				}


			}




		}


	}


  .contribute-dialog .dialog-content {
    flex: 1;
    overflow-y: auto;
    padding: 0 20px;
  }

  .contribute-dialog .dialog-footer {
    padding: 20px;
    text-align: right;
  }




</style>
